import type { Priority } from "@app/core";
import { useI18n } from "../../../lib/useI18n.js";
import { PRIORITY_PAPER } from "./palette.js";

interface Props {
  value: Priority;
  onChange: (p: Priority) => void;
  /** Matrix system governs priority: the flags become a read-only reflection of
   *  the derived priority (edit via the matrix instead). */
  readOnly?: boolean;
}

/** Priority flag tabs along the card's top edge. */
export function PriorityRail({ value, onChange, readOnly = false }: Props) {
  const { t } = useI18n();
  return (
    <div className={"priority-rail" + (readOnly ? " is-readonly" : "")} aria-readonly={readOnly || undefined}>
      {PRIORITY_PAPER.map((p) => {
        const selected = p.id === value;
        const empty = p.id === "none";
        return (
          <div
            key={p.id}
            className={"pri-tab" + (selected ? " is-selected" : "") + (empty ? " is-empty" : "")}
            style={{ ["--pcolor" as string]: p.color }}
            onClick={readOnly ? undefined : () => onChange(p.id)}
            title={readOnly ? t("matrix.priorityFromMatrix") : p.name}
            role="radio"
            aria-checked={selected}
            aria-disabled={readOnly || undefined}
          >
            <span className="flag" />
            <span className="label">{p.name}</span>
          </div>
        );
      })}
    </div>
  );
}
